<h2>Navigation</h2>
<p class="demo-description">Demonstrates <code>upp-tab-bar</code> with multiple tab buttons.</p>

<!-- Controls -->
<div class="demo-controls">
    <ion-button size="small" *ngFor="let tab of tabs" (click)="selectTab(tab.name)"
        [color]="selectedTab === tab.name ? 'primary' : 'medium'">
        {{ tab.label }}
    </ion-button>
</div>

<!-- upp-tab-bar demo -->
<div class="demo-section">
    <h3>upp-tab-bar (selected: {{ selectedTab }})</h3>
    <div style="border: 1px solid var(--ion-color-medium, #ccc); border-radius: 8px; overflow: hidden;">
        <upp-tab-bar [selected]="selectedTab" (Selected)="onTabSelected($event)">
            <upp-tab-button *ngFor="let tab of tabs"
                [tabname]="tab.name"
                [tablabel]="tab.label"
                [tabicon]="tab.icon">
            </upp-tab-button>
        </upp-tab-bar>

        <div style="padding: 24px; min-height: 120px; text-align: center;">
            <ion-icon name="checkmark-circle-outline" style="font-size: 48px; color: var(--ion-color-primary);"></ion-icon>
            <p>Active tab: <strong>{{ selectedTab }}</strong></p>
        </div>
    </div>
</div>

<!-- Multiple tab bars with different configs -->
<div class="demo-section">
    <h3>Tab bar variations</h3>

    <h4>3 tabs</h4>
    <div style="border: 1px solid var(--ion-color-medium, #ccc); border-radius: 8px; overflow: hidden; margin-bottom: 16px;">
        <upp-tab-bar selected="orders" (Selected)="onTabSelected($event)">
            <upp-tab-button tabname="orders" tablabel="Orders" tabicon="receipt-outline"></upp-tab-button>
            <upp-tab-button tabname="products" tablabel="Products" tabicon="pricetags-outline"></upp-tab-button>
            <upp-tab-button tabname="settings" tablabel="Settings" tabicon="settings-outline"></upp-tab-button>
        </upp-tab-bar>
    </div>

    <h4>5 tabs</h4>
    <div style="border: 1px solid var(--ion-color-medium, #ccc); border-radius: 8px; overflow: hidden;">
        <upp-tab-bar selected="dashboard" (Selected)="onTabSelected($event)">
            <upp-tab-button tabname="dashboard" tablabel="Dashboard" tabicon="grid-outline"></upp-tab-button>
            <upp-tab-button tabname="analytics" tablabel="Analytics" tabicon="bar-chart-outline"></upp-tab-button>
            <upp-tab-button tabname="users" tablabel="Users" tabicon="people-outline"></upp-tab-button>
            <upp-tab-button tabname="messages" tablabel="Messages" tabicon="chatbubbles-outline"></upp-tab-button>
            <upp-tab-button tabname="config" tablabel="Config" tabicon="cog-outline"></upp-tab-button>
        </upp-tab-bar>
    </div>
</div>
